import { ArrowUp } from 'lucide-react';
import { Button } from '../button/button.tsx';
import { IconButton } from '../icon-button/icon-button.tsx';
import type { ChatComposerDictation } from './chat-composer-types.ts';

interface ChatComposerSendProps {
  /** The dictation while it is recording or sending, or null while typing. */
  listening: ChatComposerDictation | null;
  canSend: boolean;
  sendLabel: string;
  /** On the button that ends a recording: "Stop and send". */
  stopLabel: string;
  /** The same button while the words are on their way back. */
  sendingLabel: string;
}

/**
 * One button in that corner, whatever the composer is doing: it ends what is
 * being said and sends it. Stopping a recording is sending it, and it says so
 * in words: an arrow alone leaves people looking for the send button they know.
 */
export function ChatComposerSend({
  listening,
  canSend,
  sendLabel,
  stopLabel,
  sendingLabel,
}: ChatComposerSendProps) {
  if (listening === null) {
    return (
      <IconButton
        type='submit'
        aria-label={sendLabel}
        disabled={!canSend}
        size='sm'
        className='bg-primary text-white hover:bg-primary-hover'
      >
        <ArrowUp size={15} aria-hidden='true' />
      </IconButton>
    );
  }

  const transcribing = listening.state === 'sending';

  return (
    <Button
      size='sm'
      disabled={transcribing}
      onClick={listening.onStop}
      className='shrink-0'
    >
      {transcribing ? (
        sendingLabel
      ) : (
        <>
          <ArrowUp size={15} aria-hidden='true' />
          {stopLabel}
        </>
      )}
    </Button>
  );
}
